import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Users, Bot, Database, MessageSquare, DollarSign, ArrowRight } from 'lucide-react';
export function AISection() {
  const steps = [{
    name: 'Tráfico',
    icon: Users
  }, {
    name: 'IA',
    icon: Bot
  }, {
    name: 'CRM',
    icon: Database
  }, {
    name: 'Seguimiento',
    icon: MessageSquare
  }, {
    name: 'Venta',
    icon: DollarSign
  }];
  return <section id="ia" className="py-24 bg-brand-black text-white relative overflow-hidden" data-id="element-13">
      {/* Tech background elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-14">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff12_1px,transparent_1px),linear-gradient(to_bottom,#ffffff12_1px,transparent_1px)] bg-[size:40px_40px]" data-id="element-15" />
      </div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-brand-cyan/20 blur-[120px] rounded-full pointer-events-none" data-id="element-16" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-17">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-18">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-brand-cyan text-sm font-semibold mb-6 border border-white/10" data-id="element-19">
            <Bot size={14} data-id="element-20" />
            <span data-id="element-21">Tecnología Avanzada</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-22">
            La IA ya está vendiendo para nuestros clientes.
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-slate-300" data-id="element-23">
            Automatizamos tareas repetitivas, mejoramos la atención y aceleramos
            el proceso comercial mediante inteligencia artificial.
          </motion.p>
        </div>

        {/* Horizontal Flow Diagram */}
        <div className="max-w-5xl mx-auto" data-id="element-24">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0" data-id="element-25">
            {steps.map((step, index) => {
            const Icon = step.icon;
            const isLast = index === steps.length - 1;
            return <Fragment key={step.name} data-id="element-26">
                  <motion.div initial={{
                opacity: 0,
                scale: 0.8
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: index * 0.15
              }} className="flex flex-col items-center relative z-10" data-id="element-27">
                    <div className={`w-20 h-20 rounded-2xl flex items-center justify-center mb-4 border shadow-glow transition-transform hover:scale-105 ${step.name === 'IA' ? 'bg-brand-cyan text-brand-black border-brand-cyan' : 'bg-white/5 text-white border-white/10 backdrop-blur-sm'}`} data-id="element-28">
                      <Icon size={32} data-id="element-29" />
                    </div>
                    <span className="font-semibold text-sm tracking-wide uppercase text-slate-300" data-id="element-30">
                      {step.name}
                    </span>
                  </motion.div>

                  {!isLast && <motion.div initial={{
                opacity: 0,
                width: 0
              }} whileInView={{
                opacity: 1,
                width: 'auto'
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: index * 0.15 + 0.2
              }} className="hidden md:flex flex-1 items-center justify-center px-4" data-id="element-31">
                      <div className="w-full h-[2px] bg-gradient-to-r from-white/10 via-brand-cyan/50 to-white/10 relative" data-id="element-32">
                        <motion.div animate={{
                    x: ['0%', '100%']
                  }} transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: 'linear'
                  }} className="absolute top-1/2 -translate-y-1/2 left-0 w-3 h-3 rounded-full bg-brand-cyan shadow-[0_0_10px_#00C8D7]" data-id="element-33" />
                      </div>
                    </motion.div>}

                  {/* Mobile connector */}
                  {!isLast && <div className="md:hidden h-8 w-[2px] bg-gradient-to-b from-white/10 via-brand-cyan/50 to-white/10 my-2" data-id="element-34" />}
                </Fragment>;
          })}
          </div>
        </div>
      </div>
    </section>;
}